<template>
  <div id="app">
    <md-progress-bar md-mode="indeterminate" class="load-b" v-if="showLoadingBar"></md-progress-bar>
    <MaterialDesignTransition :reverse="routeBack" :disabled="transitionDisabled">
      <router-view />
    </MaterialDesignTransition>
      <v-snackbar bottom right :value="updateExists" :timeout="0" color="primary">
        An update is available
        <v-btn text @click="refreshApp">
          Update
        </v-btn>
      </v-snackbar>
  </div>
</template>

<script>
import update from './mixins/update'
import MaterialDesignTransition from 'vue-router-md-transition';

export default {
  name: 'App',
  mixins: [update],
  components: {
    MaterialDesignTransition,
  },
  data: () => ({
    routeBack: false,
    transitionDisabled: false,
  }),
  watch: {
    $route(to, from) {
      // disabled for browser refresh
      this.transitionDisabled = !from.name;
      // dynamically set direction
      if (to.path === '/') {
        this.routeBack = true;
        return;
      }
      if (from.path === '/') {
        this.routeBack = false;
        return;
      }
      const toDepth = to.path.split('/').length;
      const fromDepth = from.path.split('/').length;
      this.routeBack = toDepth < fromDepth;
    },
  },
  computed: {
    showLoadingBar() {
      return this.$store.state.showLoadingBar;
    },
  },
};
</script>

<style lang="scss">
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

@import "~vue-material/dist/theme/engine";

@include md-register-theme(
  "default",
  (
    primary: #ff5f3c,
    accent: #330e2f
  )
);

@import "~vue-material/dist/theme/all";

:root {
  --md-theme-default-text-primary-on-background-variant: #979797;
  --md-theme-default-text-primary-on-background: #979797;
  --md-theme-default-icon-on-background: #979797;
}

html {
  scroll-behavior: smooth;
  overflow-x: hidden;
  &.noscroll {
    overflow-y: hidden;
  }
}

body::-webkit-scrollbar {
  display: none;
}

body {
  -ms-overflow-style: none;
  overflow-x: hidden;
}

#app {
  font-family: "Montserrat", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #979797;
}

.load-b {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 300;
}
</style>
